var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-result',{attrs:{"icon":_vm.tipData.Tip == 'SUCCESS' ? 'success' : 'error',"title":_vm.tipData.title,"subTitle":_vm.tipData.Tip == 'SUCCESS' ? '恭喜你，支付成功' : '哎呀，充值好像失败了哟！'}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.setClose}},[_vm._v("我知道了")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }